import api from './api';
import { RetreatType, ApiResponse } from '../types';

const mockRetreatTypes: RetreatType[] = [
  {
    id: '1',
    name: 'Mindfulness',
    description: 'Focus on meditation and inner peace',
    icon: 'meditation',
  },
  {
    id: '2',
    name: 'Yoga',
    description: 'Traditional yoga and wellness practices',
    icon: 'yoga',
  },
  {
    id: '3',
    name: 'Adventure',
    description: 'Outdoor activities and extreme sports',
    icon: 'adventure',
  },
  {
    id: '4',
    name: 'Wellness',
    description: 'Holistic health and wellbeing',
    icon: 'wellness',
  },
  {
    id: '5',
    name: 'Spiritual',
    description: 'Deep spiritual practices and teachings',
    icon: 'spiritual',
  },
  {
    id: '6',
    name: 'Detox',
    description: 'Body and mind cleansing programs',
    icon: 'detox',
  },
];

export const retreatTypeService = {
  async getRetreatTypes(): Promise<ApiResponse<RetreatType[]>> {
    // Mock implementation - replace with actual API call when backend is ready
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: mockRetreatTypes,
          message: 'Retreat types fetched successfully',
          success: true,
        });
      }, 600);
    });
    
    // Actual implementation (uncomment when backend is ready):
    // const response = await api.get('/retreat-types');
    // return response.data;
  },

  async getRetreatTypeById(id: string): Promise<ApiResponse<RetreatType>> {
    // Mock implementation
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const retreatType = mockRetreatTypes.find(rt => rt.id === id);
        if (retreatType) {
          resolve({
            data: retreatType,
            message: 'Retreat type fetched successfully',
            success: true,
          });
        } else {
          reject(new Error('Retreat type not found'));
        }
      }, 500);
    });
    
    // Actual implementation (uncomment when backend is ready):
    // const response = await api.get(`/retreat-types/${id}`);
    // return response.data;
  },
};
